import React, { Component, PropTypes } from 'react';
import { getCoordinatesRelativeToDocument, debounce } from 'utils/utils';

import './Popover.scss';

export default class Popover extends Component {
  static propTypes = {
    title: PropTypes.string,
    body: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    position: PropTypes.string,
    hasCloseButton: PropTypes.bool,
    closePopover: PropTypes.func,
    popoverState: PropTypes.object,
  };

  static defaultProps = {
    title: '',
    body: '',
    position: 'top',
    popoverState: {},
  }

  componentDidMount() {
    this.debouncedResizeHandler = debounce(this.handleWindowResize, 150);
    window.addEventListener('resize', this.debouncedResizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResizeHandler);
  }

  handleWindowResize = () => {
    this.forceUpdate();
  }

  render() {
    const { title, body, popoverState, hasCloseButton, closePopover } = this.props;
    let position = this.props.position;

    const boundingClientRect = popoverState.relativeRef ? popoverState.relativeRef.getBoundingClientRect() : popoverState.boundingClientRect;
    const coordinates = getCoordinatesRelativeToDocument(boundingClientRect);

    const pointerSize = 15;
    const popoverWidth = 300;

    const positionStyles = {};

    if (position === 'auto') {
      position = (boundingClientRect.top < (window.innerHeight / 2)) ? 'top' : 'bottom';
    }

    if ((position === 'top' || position === 'bottom') && boundingClientRect) {
      positionStyles.left = (coordinates.left - (popoverWidth / 2)) + (boundingClientRect.width / 2);
    }

    if (position === 'top' && boundingClientRect) {
      positionStyles.top = coordinates.top + boundingClientRect.height + pointerSize;
    }

    if (position === 'bottom' && boundingClientRect) {
      positionStyles.top = coordinates.top - pointerSize;
    }

    if ((position === 'left' || position === 'right') && boundingClientRect) {
      positionStyles.top = coordinates.top;
    }

    if (position === 'left' && boundingClientRect) {
      positionStyles.left = coordinates.left - popoverWidth - pointerSize;
    }

    if (position === 'right' && boundingClientRect) {
      positionStyles.left = coordinates.left + boundingClientRect.width + pointerSize;
    }

    if (popoverState.yOffset) {
      positionStyles.top += popoverState.yOffset;
    }

    const pointyThingStyles = {};

    // Now adjust the position if we have gone off the left or right of the screen
    if (['top', 'bottom'].includes(position)) {
      let adjustX = 0;

      if (popoverWidth + positionStyles.left > window.innerWidth) {
        adjustX = window.innerWidth - (positionStyles.left + popoverWidth);
        positionStyles.left += adjustX;
      } else if (positionStyles.left < 0) {
        adjustX = (positionStyles.left - 8) * -1;
        positionStyles.left += adjustX;
      }

      pointyThingStyles.left = (popoverWidth / 2) - adjustX;
    }

    // -component added as unique name to prevent conflicts within website project Hotel Only Multi-Room
    // Remove -component if website project CSS is removed
    return (
      <div className="popover-component" style={positionStyles}>
        <div className={`popover-component__content popover-component__content--${position}`}>
          <div className={`popover-component__content__pointy-thing popover-component__content__pointy-thing--${position}`} style={pointyThingStyles} />
          { hasCloseButton && <a href="#" className="popover-component__close-button" onClick={closePopover}><span>Close</span></a> }
          { !!title && <h3 className="popover-component__title">{title}</h3> }
          <div className="popover-component__text">
            { typeof body === 'string' ? <div dangerouslySetInnerHTML={{ __html: body }} /> : body }
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Popover/Popover.jsx
 **/